export default __webpack_public_path__ + "static/media/video_release.acbe718f.jpg";